import { useSelector } from "react-redux";
import Select from "components/input-types/Select";
import { selectMajorAssetCategory } from "./assetCategorySlice";

const MajorCategory = (props) => {
	const majorCategory = useSelector(selectMajorAssetCategory);
	const lookup = majorCategory.map((c) => ({
		id: c,
		domainCode: "majorAssetCategory",
		code: c,
		description: c,
	}));

	return <Select {...props} lookup={lookup} />;
};

export default MajorCategory;
